module.exports = __webpack_public_path__ + "static/media/specialist.74f0eb63.svg";